export default __webpack_public_path__ + "static/char-t-21-zh-Hant-a8915beae4316610b1fe7c14efa242bd.png";